/* eslint-disable max-len */
// Dependencies
import React from 'react'
import {connect} from 'react-redux'

// import Helpers from '../Helpers.js'

// Images

// Styles
import '@lazarusai/forms-ui-components/dist/index.css'
import stylesCodeBreakButton from '../styles/CodeBreakButton.module.css'
import {Icon} from '@lazarusai/forms-ui-components'

// Components

function CodeBreakButton(props) {
  return (
    <div
      className={stylesCodeBreakButton['code-break-button']}
      onClick={props.onClick}
    >
      <Icon
        icon='scissors'
      />
      <div
        className={stylesCodeBreakButton['code-break-button-text']}
      >
        Code Break
      </div>
    </div>
  )
}

const mapStateToProps = (state, ownProps) => ({
  theme: state.userReducer.theme,
  cookies: ownProps.cookies,
  storage: state.firebaseReducer.storage,
  database: state.firebaseReducer.database,
  firestore: state.firebaseReducer.firestore,
  userMessage: state.userReducer.userMessage,
  notificationType: state.userReducer.notificationType,
  notificationIcon: state.userReducer.notificationIcon,
  lang: state.userReducer.lang,
  isSignedIn: state.userReducer.isSignedIn,
  isFirebaseSignedIn: state.userReducer.isFirebaseSignedIn,
  isMFANeeded: state.userReducer.isMFANeeded,
  mfaError: state.userReducer.mfaError,
  user: state.userReducer.user,
})

export default connect(
    mapStateToProps,
    {},
)(CodeBreakButton)
